<script>
  import Process from "./Process.svelte";
  import Arrow from "./Arrow.svelte";
  import { Simulation } from "./index.js";
  import { onMount } from "svelte";
  let pcount = 6;
  let csTime = 3;
  let codeTime = 10;
  $: sim = new Simulation(pcount, codeTime, csTime);
  function getViewsFrom(s) {
    if (sim) {
      if (!sim.processes) {
        return [];
      }
    }
    return sim.processes.map(p => p.getViewObject());
  }

  $: processViews = [...getViewsFrom(sim)];

  function handleClick() {
    sim.step();
    processViews = sim.processes.map(p => p.getViewObject());
  }

  let interval;

  function setSpeedStep() {
    clearInterval(interval);
  }

  function setSpeedRegular() {
    clearInterval(interval);
    interval = setInterval(() => {
      handleClick();
    }, 1000);
  }

  function setSpeedFast() {
    clearInterval(interval);
    interval = setInterval(() => {
      handleClick();
    }, 300);
  }

  onMount(() => {
    return () => {
      clearInterval(interval);
    };
  });

  let w_width = 1024;
  let w_height = 768;
  $: svg_side = Math.min(w_width - 300, w_height);
</script>

<style>
  div#options {
    width: 300px;
    /* position: fixed; */
    top: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: start;
  }
  div.option {
    margin: 1rem;
  }
  #procs {
    text-align: left;
  }
  #procs div {
    text-align: center;
    display: flex;
    justify-content: center;
    padding: 0.5rem;
    flex: 1;
  }
  #procs div input {
    padding: 0.5rem;
    margin: 0rem 1rem 0rem 0rem;
  }
  #times div div {
    display: flex;
    justify-content: space-evenly;
  }
  #times div div input {
    margin: 0;
    padding: 0;
    width: 3rem;
  }
  #times div div span {
    /* min-width: 4rem; */
    align-self: flex-end;
    text-align: end;
    height: 100%;
    padding: 0 0.25rem 0 0;
  }

  #speed {
    display: flex;
    justify-content: stretch;
  }
  #speed button {
    flex: 1;
    margin: 0rem 0.25rem;
    padding: 0.125rem;
    text-align: center;
  }
  #speed button svg {
    width: 1rem;
    height: 1rem;
  }
  #stepper {
    display: flex;
  }
  #step {
    flex: 1;
    margin: 0rem 0.25rem;
  }

  #times div {
    text-align: left;
  }
  main {
    text-align: center;
    padding: 0;
    margin: 0 auto;
  }

  h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
  }
  #container {
    display: flex;
    flex-direction: row-reverse;
    padding: 1rem 0rem;
    margin: auto;
    justify-content: center;
  }
</style>

<svelte:window bind:innerWidth={w_width} bind:innerHeight={w_height} />
<main>
  <div id="container">
    <svg viewBox="50 -50 800 800" width={svg_side} height={svg_side}>
      <defs>
        <marker
          id="head"
          orient="auto"
          markerWidth="2"
          markerHeight="4"
          refX="0.1"
          refY="2">
          <!-- triangle pointing right (+x) -->
          <path d="M0,0 V4 L2,2 Z" fill="black" />
        </marker>
      </defs>

      <!-- <path
      d="M {450 + 200 * Math.sin(((2 * Math.PI) / pcount) * 1)}
      {300 + 200 * -Math.cos(((2 * Math.PI) / pcount) * 1)} Q {450 + 250 * Math.sin(((2 * Math.PI) / pcount) * 1.5)}
      {300 + 250 * -Math.cos(((2 * Math.PI) / pcount) * 1.5)}
      {450 + 200 * Math.sin(((2 * Math.PI) / pcount) * 2)}
      {300 + 200 * -Math.cos(((2 * Math.PI) / pcount) * 2)}
      "
      stroke="black"
      fill="transparent"
      stroke-width="2"
      marker-end="url(#head)" /> -->

      {#each processViews as p, i}
        <!-- <Process {...p} xloc={120 + i * 150} yloc="100" /> -->
        <Process
          {...p}
          xloc={450 + 250 * Math.sin(((2 * Math.PI) / pcount) * i)}
          yloc={300 + 250 * -Math.cos(((2 * Math.PI) / pcount) * i)} />
        {#if p.isReceivingToken === true}
          <Arrow from={(i - 1) % pcount} to={i % pcount} {pcount} />
        {/if}
      {/each}
    </svg>
    <div id="options">
      <h2>Options</h2>
      <div id="procs" class="option">
        <b># Processes:</b>
        <div>
          <input type="range" bind:value={pcount} min="2" max="9" />
          <span>{pcount}</span>
        </div>
      </div>
      <div id="times" class="option">
        <b>Running Times</b>
        <div id="code">
          <b>Non-CS Code:</b>
          <div class="range">

            <input type="number" bind:value={codeTime} min={1} max={100} />

          </div>
        </div>
        <div id="cs">
          <b>CS:</b>
          <div class="range">

            <input type="number" bind:value={csTime} min="1" max={100} />

          </div>
        </div>
      </div>
      <div id="speed" class="option">

        <button id="manual" on:click={setSpeedStep}>
          <svg viewbox="0 0 50 50">
            <g xmlns="http://www.w3.org/2000/svg" id="Layer_1_1_">
              <path d="M23,49V1H11v48H23z M13,3h8v44h-8V3z" />
              <path d="M39,49V1H27v48H39z M29,3h8v44h-8V3z" />
            </g>
          </svg>
        </button>
        <button id="default" on:click={setSpeedRegular}>
          <svg viewbox="0 0 50 50">
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M7,1.217v47.566L45.918,25L7,1.217z
              M9,4.783L42.082,25L9,45.217V4.783z" />

          </svg>
        </button>
        <button id="fast" on:click={setSpeedFast}>
          <svg viewbox="0 0 50 50">
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M24,49.414L48.414,25L24,0.586v23l-23-23v48.828l23-23V49.414z
              M3,44.586V5.414L22.586,25L3,44.586z M26,5.414L45.586,25
              L26,44.586V5.414z" />
          </svg>
        </button>
      </div>
      <div id="stepper" class="option">
        <button id="step" on:click={handleClick}>Step</button>
      </div>
    </div>
  </div>
</main>
